import {
  TRESPONSE_ORDER_UPLOAD_DETAILS,
  TRESPONSE_ORDER_LIST,
  TRESPONSE_ORDER_MULTIPLE_FACTORY_ALLOCATIONS,
  TFilterSelected,
  TOrderListingBucketInfo,
  TOrderListViewType,
} from '@monorepo/types';
import { TFilterGroupModel, TUserPaginationOption } from '@monorepo/ui';

export type TOrderListState = {
  orderListInfo: TRESPONSE_ORDER_LIST | null;
  userPaginationOption: TUserPaginationOption;
  orderUploadDetailsInfo: TRESPONSE_ORDER_UPLOAD_DETAILS | null;
  orderToFactoriesAllocationInfo: TRESPONSE_ORDER_MULTIPLE_FACTORY_ALLOCATIONS | null;
  orderListSelectedFilters: TFilterGroupModel<TFilterSelected> | null;
  orderListViewType: TOrderListViewType;
};

export const TOrderListActionType = {
  GetOrderList: 'GET_ORDER_LIST' as const,
  GetOrderListSuccess: 'GET_ORDER_LIST_SUCCESS' as const,
  GetOrderListFailure: 'GET_ORDER_LIST_FAILURE' as const,
  SetUserPaginationOption: 'SET_ORDER_LIST_USER_PAGINATION_OPTION' as const,
  GetOrderUploadDetails: 'GET_ORDER_UPLOAD_DETAILS' as const,
  GetOrderUploadDetailsSuccess: 'GET_ORDER_UPLOAD_DETAILS_SUCCESS' as const,
  GetOrderUploadDetailsFailure: 'GET_ORDER_UPLOAD_DETAILS_FAILURE' as const,
  AssignTnaToOrders: 'ASSIGN_TNA_TO_ORDERS' as const,
  AssignTnaToOrdersSuccess: 'ASSIGN_TNA_TO_ORDERS_SUCCESS' as const,
  AssignTnaToOrdersFailure: 'ASSIGN_TNA_TO_ORDERS_FAILURE' as const,
  AssignSingleFactoryToOrder: 'ASSIGN_SINGLE_FACTORY_TO_ORDER' as const,
  AssignSingleFactoryToOrderSuccess: 'ASSIGN_SINGLE_FACTORY_TO_ORDER_SUCCESS' as const,
  AssignSingleFactoryToOrderFailure: 'ASSIGN_SINGLE_FACTORY_TO_ORDER_FAILURE' as const,
  ViewFactoryAllocation: 'VIEW_FACTORY_ALLOCATION' as const,
  ViewFactoryAllocationSuccess: 'VIEW_FACTORY_ALLOCATION_SUCCESS' as const,
  ViewFactoryAllocationFailure: 'VIEW_FACTORY_ALLOCATION_FAILURE' as const,
  GetOrderToFactoriesSplitView: 'GET_ORDER_TO_FACTORIES_SPLIT_VIEW' as const,
  GetOrderToFactoriesSplitViewSuccess: 'GET_ORDER_TO_FACTORIES_SPLIT_VIEW_SUCCESS' as const,
  GetOrderToFactoriesSplitViewFailure: 'GET_ORDER_TO_FACTORIES_SPLIT_VIEW_FAILURE' as const,
  AllocateOrderToMultipleFactories: 'ALLOCATE_ORDER_TO_MULTIPLE_FACTORIES' as const,
  AllocateOrderToMultipleFactoriesSuccess: 'ALLOCATE_ORDER_TO_MULTIPLE_FACTORIES_SUCCESS' as const,
  AllocateOrderToMultipleFactoriesFailure: 'ALLOCATE_ORDER_TO_MULTIPLE_FACTORIES_FAILURE' as const,
  GetOrderToFactoriesSplit: 'GET_ORDER_TO_FACTORIES_SPLIT' as const,
  GetOrderToFactoriesSplitSuccess: 'GET_ORDER_TO_FACTORIES_SPLIT_SUCCESS' as const,
  GetOrderToFactoriesSplitFailure: 'GET_ORDER_TO_FACTORIES_SPLIT_FAILURE' as const,
  DeleteOrders: 'DELETE_ORDERS' as const,
  DeleteOrdersSuccess: 'DELETE_ORDERS_SUCCESS' as const,
  DeleteOrdersFailure: 'DELETE_ORDERS_FAILURE' as const,
  ViewOrderFactoryAllocation: 'VIEW_ORDER_FACTORY_ALLOCATION' as const,
  ViewOrderFactoryAllocationSuccess: 'VIEW_ORDER_FACTORY_ALLOCATION_SUCCESS' as const,
  ViewOrderFactoryAllocationFailure: 'VIEW_ORDER_FACTORY_ALLOCATION_FAILURE' as const,
  SetOrderListSelectedFilters: 'SET_ORDER_LIST_SELECTED_FILTERS' as const,
  SetOrderListBucketInfo: 'SET_ORDER_LIST_BUCKET_INFO' as const,
};
